import { isLength, isStrongPassword } from 'validator';
import { VALIDATE_CODE } from './fieldConstants';
/**
 * Validate password
 * 8-32 kí tự, ít nhất 1 chữ hoa, 1 chữ thường, 1 số, 1 kí tự đặc biệt (trừ dấu cách)
 * @param key
 * @returns
 */
export const validEncryptionKey = (key) => {
    if (!key)
        return VALIDATE_CODE.REQUIRED;
    if (!isLength(key, { max: 32 }))
        return VALIDATE_CODE.MAX_LENGTH;
    if (!isStrongPassword(key, {
        minLength: 8,
        minLowercase: 1,
        minUppercase: 1,
        minNumbers: 1,
        minSymbols: 1
    }) || /\s/.test(key))
        return VALIDATE_CODE.STRONG_FORMAT;
    return VALIDATE_CODE.OK;
};
export const validateDifferent = (value, reValue) => {
    if (value !== reValue)
        return VALIDATE_CODE.DIFFERENT;
    return VALIDATE_CODE.OK;
};
